import './full-extend.css'

export default function (L, type) {
    L.Control.fullExtend = L.Control.extend({
        options: {
            position: 'topleft',
        },
        onAdd: (map) => {
            const div = L.DomUtil.create('div')
            const button = document.createElement('button')
            button.className = 'full-extend-btn'
            button.onclick = (e) => {
                const event = new CustomEvent('full-extend', {
                    detail: {type}
                });
                window.dispatchEvent(event)
            }
            div.appendChild(button)

            return div
        },
    })

    L.control.fullExtend = function (options) {
        return new L.Control.fullExtend(options);
    };
}